import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { X } from 'lucide-react'
import { Button } from 'components/ui/Button'

interface OfferDetailFullPageOverlayProps {
  title: string
  onClose: () => void
  children: React.ReactNode
}

export function OfferDetailFullPageOverlay({ title, onClose, children }: OfferDetailFullPageOverlayProps) {
  const { t } = useTranslation()

  useEffect(() => {
    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = previousOverflow
    }
  }, [])

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [onClose])

  return (
    <div className="fixed inset-y-0 right-0 z-50 flex flex-col bg-[#EFF1F6] left-0 lg:left-[264px] dark:bg-[#14161c]">
      <div className="flex h-14 shrink-0 items-center justify-between border-b border-[#D8D8D8]/80 bg-[#EFF1F6] px-4 sm:px-6 lg:px-8 dark:border-border dark:bg-[#14161c]">
        <h2 className="text-lg font-semibold text-foreground">{title}</h2>
        <Button
          type="button"
          variant="outline"
          size="icon"
          onClick={onClose}
          className="h-10 w-10 shrink-0 rounded-md"
          aria-label={t('common.close', 'Close')}
          title={t('common.close', 'Close')}
        >
          <X className="h-5 w-5" />
        </Button>
      </div>
      <div className="flex-1 overflow-y-auto px-4 py-6 sm:px-6 lg:px-8">{children}</div>
    </div>
  )
}
